import apiClient from './client'

export default {
  getAll({ includeMine = false } = {}) {
    return apiClient.get('/zones', { params: includeMine ? { include_mine: 'true' } : {} })
  },

  getBySlug(slug) {
    return apiClient.get(`/zones/${slug}`)
  },

  getNearest(lat, lon, limit = 10) {
    return apiClient.get('/zones/nearest', { params: { lat, lon, limit } })
  },

  getTrails(slug) {
    return apiClient.get(`/zones/${slug}/trails`)
  },

  getPois(slug) {
    return apiClient.get(`/zones/${slug}/pois`)
  },

  getIntersecting(minLon, minLat, maxLon, maxLat, { includeMine = false } = {}) {
    return apiClient.get('/zones/intersecting', {
      params: {
        min_lon: minLon,
        min_lat: minLat,
        max_lon: maxLon,
        max_lat: maxLat,
        ...(includeMine && { include_mine: 'true' }),
      },
    })
  },

  propose(payload) {
    return apiClient.post('/zones', { zone: payload })
  },

  approve(slug) {
    return apiClient.post(`/zones/${slug}/approve`)
  },

  reject(slug, rejectionReason) {
    return apiClient.post(`/zones/${slug}/reject`, { rejection_reason: rejectionReason })
  },
}
